var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded",style:({ background: `url(${_vm.imageBg})` })},[_c('div',{staticClass:"d-flex flex-column"},_vm._l((_vm.messages),function(message,i){return _c('wa-message-view',{key:i,class:message.incoming ? 'mr-auto' : 'ml-auto',attrs:{"message":message}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }